import type { PriorityLevel } from '@travel-planner/shared/schemas/operations';

// Priority levels: value is the stored numeric string. The three non-VIP levels
// keep their legacy swatch colours; the four VIP levels use an amber→red ramp
// that gets darker as the level rises (VIP lightest, VIP+ strongest) so the
// Operations team reads the client's VIP tier at a glance (XT T-148 — the old
// pastel blues had too little visual weight and no perceivable ordering).
export type PriorityOption = {
  value: PriorityLevel;
  label: string;
  color: string;
};

export const PRIORITY_OPTIONS: readonly PriorityOption[] = [
  { value: '5', label: 'Not verified', color: '#c8b59a' },
  { value: '10', label: 'Inconsistent', color: '#f5c7a1' },
  { value: '15', label: 'Confirmed', color: '#f5d26b' },
  { value: '20', label: 'VIP', color: '#fb923c' },
  { value: '40', label: 'VIPP', color: '#f97316' },
  { value: '60', label: 'VIPPP', color: '#e11d48' },
  { value: '80', label: 'VIP+', color: '#9f1239' },
];

const byValue = new Map(PRIORITY_OPTIONS.map((p) => [p.value, p]));

export const priorityColor = (value: string | null): string | undefined =>
  value ? byValue.get(value as PriorityLevel)?.color : undefined;

export const priorityLabel = (value: string | null): string | undefined =>
  value ? byValue.get(value as PriorityLevel)?.label : undefined;
